/**
 * TTG INP-Hebel 1 (27.09.2026): Produktkarten geben nur die erste Galerie-Folie sofort aus. Alle weiteren Folien stehen
 * gesammelt in <template data-ttg-folien> (snippets/card-gallery.liquid). Dieses Modul setzt sie beim ersten Kontakt mit der
 * Karte ein — pointerenter, touchstart, Tastaturfokus oder Varianten-Auswahl per Farbfeld — einmal je Karte (danach gibt es
 * kein Template mehr). Die Slideshow wird dabei kurz aus- und wieder eingehängt: slideshow.js richtet die Steuerung beim
 * Verbinden nach der Folienzahl ein (≤ 1 Folie: ohne Steuerung, assets/slideshow.js Z. 140).
 */
const VORLAGE = 'template[data-ttg-folien]';

/** @param {EventTarget | null} ziel */
function einsetzen(ziel) {
  if (!(ziel instanceof Element)) return;
  const karte = ziel.closest('product-card') || ziel.closest('.card-gallery');
  if (!karte) return;
  for (const vorlage of karte.querySelectorAll(VORLAGE)) {
    const show = vorlage.closest('slideshow-component');
    const eltern = show ? show.parentNode : null;
    if (!show || !eltern) {
      vorlage.replaceWith(vorlage.content);
      continue;
    }
    const danach = show.nextSibling;
    const aktiv = document.activeElement;
    const fokusDrin = aktiv instanceof HTMLElement && show.contains(aktiv);
    eltern.removeChild(show);
    vorlage.replaceWith(vorlage.content);
    eltern.insertBefore(show, danach);
    if (fokusDrin && aktiv.isConnected) aktiv.focus({ preventScroll: true });
  }
}

/**
 * Solange nur Folie 1 steht, richtet slideshow.js keine Steuerung ein und sperrt verschachtelte Karten (Karte in einem
 * Produkt-Schieberegler) nicht — deren unsichtbare Pfeile wären antippbar. Dieselbe Sperre wie slideshow.js Z. 591 vorab.
 * @param {ParentNode} wurzel
 */
function sperren(wurzel) {
  for (const vorlage of wurzel.querySelectorAll(VORLAGE)) {
    const show = vorlage.closest('slideshow-component');
    const verschachtelt = show && show.parentElement && show.parentElement.closest('slideshow-component');
    if (verschachtelt && show.getAttribute('disabled') !== 'true') show.setAttribute('disabled', 'true');
  }
}

for (const typ of ['pointerenter', 'touchstart', 'focusin']) {
  document.addEventListener(typ, (e) => einsetzen(e.target), { capture: true, passive: true });
}
document.addEventListener('variant:selected', (e) => einsetzen(e.target), { capture: true });
sperren(document);
